import React from 'react';
import { useAuth } from '../context/AuthContext';

const Unauthorized: React.FC = () => {
  const { currentUser, logout } = useAuth();

  return (
    <div className="md-page">
      <div className="md-content">
        <div className="unauthorized-container">
          <div className="md-empty-state">
            <div className="md-empty-state__icon">🚫</div>
            <h3 className="md-empty-state__title">Access Denied</h3>
            <p className="md-empty-state__description">
              You don't have permission to access this page. Your current role is <strong>{currentUser?.role}</strong>.
            </p>
            <div className="md-empty-state__actions">
              <button 
                className="md-button md-button--filled"
                onClick={() => window.history.back()}
              >
                Go Back
              </button>
              <button 
                className="md-button md-button--text"
                onClick={logout}
              >
                Switch Account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;